import { ConfigProvider } from 'antd';
import { selectUserConfigLanguageId } from 'app/userPreferences/selectors';
import { useAppSelector } from 'store/hooks';
import { ReactNode } from 'react';
import {
  token,
} from 'theme/theme';
import { locales } from 'constants/locale/antd';

const antdTheme = { token };
type LocaleKey = keyof typeof locales;

export const LocaleConfigProvider = ({ children }: { children: ReactNode }) => {
  const localeLanguage = useAppSelector(selectUserConfigLanguageId);

  return (
    <ConfigProvider locale={locales[localeLanguage as LocaleKey]} theme={antdTheme}>
      {children}
    </ConfigProvider>
  );
};
